const instagramApiFactory = (axios) => ({
  getProfile: async (componentId) => (await axios.get(`/instagram/${componentId}`)).data,
});

export { instagramApiFactory };
